import React, { useEffect, useState } from "react";
import { SelectBox } from "devextreme-react/select-box";
import INTAKE_API from "api/intakeApi";
import { useFetch } from "@hooks/useBatchIntakeApi";
import { useLocation } from "react-router-dom";

import BatchFilterDropdown from "./BatchFilterDropdown";

const FilterDropdown = ({ setSupplierName, suppliers, selectSupplier, setSelectSupplier, setSelectBatch, setBatchData }) => {
const [newsup, setNewsup] = useState(null);
const location = useLocation();

useEffect(() => {
  if (!suppliers?.data?.length) return;

  const supplierIdFromStorage = localStorage.getItem("supplierId");
  let matchedSupplier = null;

  if (supplierIdFromStorage) {
    // ✅ Ensure parseInt to get number
    const id = parseInt(supplierIdFromStorage, 10);
    matchedSupplier = suppliers.data.find(
      (supplier) => supplier.supplierID === id
    );
  }

  if (!matchedSupplier) {
    matchedSupplier = suppliers.data[0];
  }

  if (matchedSupplier) {
    setSelectSupplier(Number(matchedSupplier.supplierID)); // ✅ Force number
    setSupplierName?.(matchedSupplier.name);
    localStorage.setItem("supplierId", matchedSupplier.supplierID.toString()); // ✅ Save as string (optional)
    localStorage.setItem("supplierName", matchedSupplier.name);
  }
}, [suppliers, location.pathname]);
console.log("Suppliers:", suppliers?.data);
console.log("Selected supplier:", selectSupplier, typeof selectSupplier);

  return (
    <React.Fragment>
      <div className='flex flex-col lg:flex-row sm:flex-row lg:items-center sm:items-center items-start'>
        {/* <BatchFilterDropdown setSelectSupplier={setSelectSupplier} selectSupplier={selectSupplier} /> */}

        <label className="text-sm me-2">Select Supplier</label>
        {suppliers?.data?.length > 0 && selectSupplier !== null && (
          <SelectBox
            dataSource={suppliers?.data}
            displayExpr="name" // Display text
            valueExpr="supplierID" // Value field
            value={Number(selectSupplier)} // Set the selected value
            onValueChanged={(e) => {
              const selectedId = e.value;
              const selected = suppliers.data.find(
                (s) => s.supplierID === selectedId
              );
  
              setSelectSupplier(selectedId);
              setSupplierName?.(selected?.name);

              // localStorage.setItem("supplierId", e.value);
              // localStorage.setItem("supplierName", e?.component?.option("text")); // Store supplier name in localStorage
              setBatchData(null)
              setSelectBatch(null); // Reset batch selection when supplier changes

              // setSelectBatch(null); // Reset batch selection when supplier changes
            }}
            className="w-auto lg:w-1/2 sm:w-1/2 me-3"
            placeholder="Select an option"
            
            searchEnabled={true}
            
          />
        )
        }
      </div>
    </React.Fragment>
  );
};

export default FilterDropdown;
